"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _format = _interopRequireDefault(require("date-fns/format"));

var _reactNativeWeb = require("react-native-web");

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _AaLocationPicker = _interopRequireDefault(require("../containers/airasia-placepicker-container/AaLocationPicker.component"));

var _AaPassengerRoomSelection = _interopRequireDefault(require("../containers/airasia-room-selection-container/AaPassengerRoomSelection.component"));

var _AaPassengerRoomSelection2 = require("../containers/airasia-room-selection-container/AaPassengerRoomSelection.model");

var _AaPassengerRoomSelection3 = _interopRequireDefault(require("../containers/airasia-room-selection-container/AaPassengerRoomSelection.translation"));

var _airasiaMobileHeaderContainer = require("../containers/airasia-mobile-header-container");

var _uiUtils = require("@airasia/ui-utils");

var _AaHelpers = require("../../utils/AaHelpers");

var _AaSearchUrl = _interopRequireWildcard(require("../../utils/AaSearchUrl"));

var _AaPlatform = _interopRequireDefault(require("../../utils/AaPlatform"));

var _AaNativeModules = _interopRequireDefault(require("../../utils/AaNativeModules"));

var _AaRecentSearchesRepository = _interopRequireDefault(require("../../utils/AaRecentSearchesRepository"));

var _AaFeatureFlag = require("../../utils/AaFeatureFlag");

var _AaHooks = require("../../utils/AaHooks");

var _AaConstants = require("../../utils/AaConstants");

var _AaCalendar = _interopRequireDefault(require("../containers/airasia-calendar-container/AaCalendar.component"));

var _AaCalendar2 = require("../containers/airasia-calendar-container/AaCalendar.model");

var _SearchFormStyles = _interopRequireDefault(require("./SearchFormStyles"));

var _SearchAgain = _interopRequireDefault(require("./SearchAgain.styles"));

var _EnvironmentUrl = _interopRequireDefault(require("../../config/environment/EnvironmentUrl"));

var _stateVariables = _interopRequireDefault(require("../../config/stateVariables"));

var _DefaultConfig = _interopRequireDefault(require("../../config/DefaultConfig"));

var _CtripMapCity = _interopRequireDefault(require("../../config/CtripMapCity"));

var _GTMTracking = require("../../utils/GTMTracking");

var _AaCookie = require("../../utils/AaCookie");

var _AaCalendar3 = require("../containers/airasia-calendar-container/AaCalendar.utilities");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var MAX_RANGE_DAYS = 90;
var DEFAULT_ADULT_COUNT = 2;
var HOTEL_CITY_TYPE = 'City';
var AGE_DATA = [{
  label: 'Under 1',
  value: 0
}, {
  label: '1',
  value: 1
}, {
  label: '2',
  value: 2
}, {
  label: '3',
  value: 3
}, {
  label: '4',
  value: 4
}, {
  label: '5',
  value: 5
}, {
  label: '6',
  value: 6
}, {
  label: '7',
  value: 7
}, {
  label: '8',
  value: 8
}, {
  label: '9',
  value: 9
}, {
  label: '10',
  value: 10
}, {
  label: '11',
  value: 11
}, {
  label: '12',
  value: 12
}, {
  label: '13',
  value: 13
}, {
  label: '14',
  value: 14
}, {
  label: '15',
  value: 15
}, {
  label: '16',
  value: 16
}, {
  label: '17',
  value: 17
}];

var SearchForm = function SearchForm(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      searchWidgetModalStatus = _useState2[0],
      setSearchWidgetModalStatus = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      selectedDestination = _useState4[0],
      setSelectedDestination = _useState4[1];

  var _useState5 = (0, _react.useState)([(0, _AaPassengerRoomSelection2.buildRoomModel)(DEFAULT_ADULT_COUNT)]),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      roomOccupancy = _useState6[0],
      setRoomOccupancy = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      syncPlacePickerData = _useState8[0],
      setSyncPlacePickerData = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      inputStylingChange = _useState10[0],
      setInputStylingChange = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      destinationSelected = _useState12[0],
      isDestinationSelected = _useState12[1];

  var _useState13 = (0, _react.useState)(true),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      destinationValid = _useState14[0],
      setDestinationValidState = _useState14[1];

  var _useState15 = (0, _react.useState)(null),
      _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
      baseCurrency = _useState16[0],
      setBaseCurrency = _useState16[1];

  var _useState17 = (0, _react.useState)(1),
      _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
      exchangeRate = _useState18[0],
      setExchangeRate = _useState18[1];

  var _useState19 = (0, _react.useState)(true),
      _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
      disableSearchButton = _useState20[0],
      setDisableSearchButton = _useState20[1];

  var _useState21 = (0, _react.useState)(null),
      _useState22 = (0, _slicedToArray2["default"])(_useState21, 2),
      redirectionUrl = _useState22[0],
      setRedirectionUrl = _useState22[1];

  var _useState23 = (0, _react.useState)(false),
      _useState24 = (0, _slicedToArray2["default"])(_useState23, 2),
      isLoadingSearchButton = _useState24[0],
      setIsLoadingSearchButton = _useState24[1];

  var _useState25 = (0, _react.useState)(props.controls.currency.toUpperCase()),
      _useState26 = (0, _slicedToArray2["default"])(_useState25, 2),
      collectedCurrency = _useState26[0],
      setCollectedCurrency = _useState26[1];

  var _useState27 = (0, _react.useState)(null),
      _useState28 = (0, _slicedToArray2["default"])(_useState27, 2),
      finalAAGoRedirectionUrl = _useState28[0],
      setFinalAAGoRedirection = _useState28[1];

  var _useState29 = (0, _react.useState)(_reactNativeWeb.AppState.currentState),
      _useState30 = (0, _slicedToArray2["default"])(_useState29, 2),
      appState = _useState30[0],
      setAppState = _useState30[1];

  var _useState31 = (0, _react.useState)(''),
      _useState32 = (0, _slicedToArray2["default"])(_useState31, 2),
      destinationSearchTerm = _useState32[0],
      setDestinationSearchTerm = _useState32[1];

  var category = _AaConstants.TRACKING_CONSTANTS.category,
      actions = _AaConstants.TRACKING_CONSTANTS.actions,
      screenName = _AaConstants.TRACKING_CONSTANTS.screenName,
      lineofbusiness = _AaConstants.TRACKING_CONSTANTS.lineofbusiness; //call back to increase width wwhen focused in desktop

  var onInputMakeStyleChange = function onInputMakeStyleChange(bool) {
    setInputStylingChange(bool);
  };

  var _useState33 = (0, _react.useState)({
    checkinDate: null,
    checkoutDate: null
  }),
      _useState34 = (0, _slicedToArray2["default"])(_useState33, 2),
      tripDates = _useState34[0],
      setTripDates = _useState34[1];
  /*
  * Decide Screens
  * */


  var mobileScreen = props.layout <= _crossPlatformComponents.LAYOUT.mobile;
  var tabletScreen = props.layout > _crossPlatformComponents.LAYOUT.mobile && props.layout <= _crossPlatformComponents.LAYOUT.tablet;
  var desktopScreen = props.layout > _crossPlatformComponents.LAYOUT.tablet;
  var showMobileWeb = _AaPlatform["default"].IS_WEB && (mobileScreen || props.controls.forceMobileView);

  var updatePassengerCountHandler = function updatePassengerCountHandler(paxCount) {
    setRoomOccupancy(paxCount);
    trackRoomAdded(paxCount);
  }; //snap channel api call


  _react["default"].useEffect(function () {
    var environment = props.controls.environment;
    var urls = _EnvironmentUrl["default"][environment];
    props.make_async_get_call(urls.CHANNEL, null, _stateVariables["default"].channel);
    props.make_async_get_call(urls.SNAP_AOC, null, _stateVariables["default"].aoc);
    props.make_async_get_call(urls.NEAREST_AIRPORT_ENDPOINT, null, _stateVariables["default"].nearest_airports);
    props.make_async_get_call(urls.FEATURE_FLAG, null, _stateVariables["default"].feature_flag);
    props.make_async_get_call(urls.HOTEL_CONFIG, null, _stateVariables["default"].config);
  }, []);
  /*
  * Use by mobile platform to decide if app is in foreground or background and take necessary actions
  * */


  _react["default"].useEffect(function () {
    _reactNativeWeb.AppState.addEventListener('change', _handleAppStateChange);

    return function () {
      _reactNativeWeb.AppState.removeEventListener('change', _handleAppStateChange);
    };
  });

  var _handleAppStateChange = function _handleAppStateChange(nextAppState) {
    setAppState(nextAppState);
  };
  /*
  * componentDidMount effect : How the component is mounted the first time for mobile web or mobile platform and
  * localstorage to fetch the recent storage items
  *  */


  _react["default"].useEffect(function () {
    if (mobileScreen || showMobileWeb) {
      setSearchWidgetModalStatus(true);
      setSyncPlacePickerData(true);
    }

    if (_AaPlatform["default"].IS_MOBILE) {
      setSearchWidgetModalStatus(true);
      setSyncPlacePickerData(true);
    }

    var recentSearches = _AaRecentSearchesRepository["default"].getRecentSearches();

    if (recentSearches.length > 0) {
      setLocalStorageTripDates(recentSearches[0].date);
    }
  }, [props.controls.locale]);

  _react["default"].useEffect(function () {
    if (showMobileWeb || _AaPlatform["default"].IS_MOBILE) {
      var _props$controls = props.controls,
          environment = _props$controls.environment,
          locale = _props$controls.locale;
      var productTileUrl = (0, _AaHelpers.format)(_EnvironmentUrl["default"][environment].PRODUCT_TILES, [locale]);
      props.make_async_get_call(productTileUrl, null, _stateVariables["default"].product_tiles, false);
    }
  }, [props.controls.locale]);
  /*
  * Prefill strategy for the component
  * */


  _react["default"].useEffect(function () {
    var _props$controls$preFi = props.controls.preFill,
        preFill = _props$controls$preFi === void 0 ? {} : _props$controls$preFi;

    if (preFill.destination) {
      setSelectedDestination(preFill.destination);
    }
  }, [props.controls.preFill.destination]);

  _react["default"].useEffect(function () {
    var _props$controls$preFi2 = props.controls.preFill,
        preFill = _props$controls$preFi2 === void 0 ? {} : _props$controls$preFi2;
    var hasRoomOccupancy = preFill.roomOccupancy && preFill.roomOccupancy.length > 0;

    if (hasRoomOccupancy && preFill.roomOccupancy.length <= _AaPassengerRoomSelection2.MAX_ROOM_COUNT) {
      setRoomOccupancy(preFill.roomOccupancy);
    }
  }, [props.controls.preFill.roomOccupancy]);

  _react["default"].useEffect(function () {
    var _props$controls$preFi3 = props.controls.preFill,
        preFill = _props$controls$preFi3 === void 0 ? {} : _props$controls$preFi3;

    if (preFill.checkin || preFill.checkout) {
      setTripDates({
        checkinDate: preFill.checkin ? new Date(preFill.checkin) : null,
        checkoutDate: preFill.checkout ? new Date(preFill.checkout) : null
      });
    }
  }, [props.controls.preFill.checkin, props.controls.preFill.checkout]);

  _react["default"].useEffect(function () {
    if (tabletScreen) {
      setSyncPlacePickerData(true);
    }
  }, [tabletScreen]);

  _react["default"].useEffect(function () {
    setSyncPlacePickerData(true);
  }, [mobileScreen]);
  /*
  * checkinDate and checkoutDate set from either localstorage or prefill values
  * */


  var setLocalStorageTripDates = function setLocalStorageTripDates(dates) {
    if (props.controls.preFill && (props.controls.preFill.hasOwnProperty("depart") && props.controls.preFill["depart"] || props.controls.preFill.hasOwnProperty("return") && props.controls.preFill["return"])) {} else {
      if (!dates) {
        return;
      }

      var checkinDate = dates.checkin && Date.parse(dates.checkin) ? new Date(dates.checkin) : null;
      var checkoutDate = dates.checkin && Date.parse(dates.checkout) ? new Date(dates.checkout) : null;
      setTripDates({
        checkinDate: checkinDate,
        checkoutDate: checkoutDate
      });
    }
  };

  var _useState35 = (0, _react.useState)(false),
      _useState36 = (0, _slicedToArray2["default"])(_useState35, 2),
      showFormErrors = _useState36[0],
      setShowFormErrors = _useState36[1];

  var featureFlags = (0, _AaHooks.useAsyncData)(props.async_feature_flag, _AaFeatureFlag.parseFeatureFlags, _AaFeatureFlag.DEFAULT_FEATURE_FLAGS);
  var config = (0, _AaHooks.useAsyncData)(props.async_config, _AaFeatureFlag.parseConfig, _AaFeatureFlag.DEFAULT_HOTEL_CONFIG);
  var channels = (0, _AaHooks.useAsyncData)(props.async_channel, undefined, _AaFeatureFlag.DEFAULT_CHANNEL_HASH);
  var passengerSelectionConfig = {
    controls: {
      min: {
        adult: 1,
        child: 0,
        infant: 0
      },
      max: {
        adult: 12,
        child: 6,
        infant: 6
      },
      onUpdate: updatePassengerCountHandler,
      isMobilePlatform: _AaPlatform["default"].IS_MOBILE,
      isMobileLayout: mobileScreen || showMobileWeb,
      enableMultipleRooms: featureFlags.HOTEL_ENABLE_MULTIPLE_ROOMS
    }
  };
  /*
  * CTA : Decide if the route is Kiwi or AA and route accordingly for both web and mobile platform
  * Web : Navigation specified in the code
  * Mobile : React native bridge is provided to pass the contructed object accordingly
  * Recent Search : LocalStorage in case of web and AsyncStorage in case of mobile
  * */

  var performMobileRedirect = function performMobileRedirect(payloadForMobile) {
    if (_AaPlatform["default"].IS_ANDROID) {
      _AaNativeModules["default"].ReactToNative.searchClicked();
    }

    var stringPayload = JSON.stringify(payloadForMobile);

    _AaNativeModules["default"].ReactToNative.searchHotel(stringPayload);
  };

  var trackRoomAdded = function trackRoomAdded(newRoomOccupancy) {
    // Only track when adding new room
    if (newRoomOccupancy.length > roomOccupancy.length) {
      (0, _GTMTracking.trackEventNoEcommerce)({
        category: 'hpsearchwidget',
        action: 'search',
        label: "Hotel SA | Room ".concat(newRoomOccupancy.length, " Added")
      });
    }
  };

  var trackSearchHotel = function trackSearchHotel() {
    if (!selectedDestination) return;

    var _roomOccupancy$reduce = roomOccupancy.reduce(function (result, item) {
      if (item.adult) {
        result.adults = result.adults + item.adult;
      }

      if (item.child) {
        result.child = result.child + item.child;
      }

      if (item.infant) {
        result.child = result.child + item.infant;
      }

      return result;
    }, {
      adults: 0,
      child: 0
    }),
        adults = _roomOccupancy$reduce.adults,
        child = _roomOccupancy$reduce.child;

    var destination = "".concat(selectedDestination.name);
    var checkin = (0, _format["default"])(tripDates.checkinDate, _AaSearchUrl.AA_DATE_FORMAT);
    var checkout = (0, _format["default"])(tripDates.checkoutDate, _AaSearchUrl.AA_DATE_FORMAT);
    var numberOfRooms = roomOccupancy.length;

    if (_AaPlatform["default"].IS_WEB) {
      (0, _GTMTracking.trackEventNoEcommerce)({
        category: category,
        action: 'click',
        label: "".concat(destination, "|").concat(checkin, "-").concat(checkout, "|").concat(numberOfRooms).concat(numberOfRooms > 1 ? 'Rooms' : 'Room', "|ADL=").concat(adults, ",CHD=").concat(child)
      });
    } else {
      var totalpax = adults + child;

      var lengthofstay = _AaCalendar3.AaCalendarUtilities.dayDifference(tripDates.checkinDate, tripDates.checkoutDate);

      var ecommerceInfo = {
        destination: destination,
        destinationcategory: selectedDestination.type,
        destinationcountry: selectedDestination.country_code,
        checkindate: checkin,
        checkoutdate: checkout,
        lengthofstay: lengthofstay,
        rooms: numberOfRooms,
        totalpax: totalpax,
        adult: adults,
        child: child,
        screenName: screenName,
        lineofbusiness: lineofbusiness
      };
      (0, _GTMTracking.trackEventEcommerce)(actions.search, ecommerceInfo);
    }
  };

  var trackRedirectedTarget = function trackRedirectedTarget(target) {
    (0, _GTMTracking.trackEventNoEcommerce)({
      category: 'hpsearchwidget',
      action: 'click',
      label: "hotel sa | ".concat(target)
    });
  };

  var trackSelectedDestination = function trackSelectedDestination(destination, selectedIndex) {
    var name = destination.name,
        type = destination.type,
        isRecentSearches = destination.isRecentSearches;
    var searchTerm;

    if (!destinationSearchTerm || typeof destinationSearchTerm === 'string' && destinationSearchTerm.includes('undefined')) {
      searchTerm = '';
    } else {
      searchTerm = destinationSearchTerm;
    }

    var label = "".concat(searchTerm, "(").concat(isRecentSearches ? 'recent.hs.list' : 'gnral', ")|").concat(name, "|").concat(type || '');

    if (_AaPlatform["default"].IS_WEB) {
      (0, _GTMTracking.trackEventNoEcommerce)({
        category: category,
        action: actions.click,
        label: label
      });
    } else {
      var ecommerceInfo = {
        category: category,
        action: actions.tap,
        label: label,
        screenName: screenName,
        lineofbusiness: lineofbusiness
      };
      (0, _GTMTracking.trackEventEcommerce)(actions.tap, ecommerceInfo);
    }
  };

  var trackEmptySearchField = function trackEmptySearchField() {
    (0, _GTMTracking.trackEventNoEcommerce)({
      category: 'hpsearchwidget Error',
      action: 'click',
      label: 'Hotel SA | empty search field'
    });
  };

  var canShowChinaDisclaimer = function canShowChinaDisclaimer() {
    var countryCode = (0, _get2["default"])(props, 'async_nearest_airports.userData.data.country');
    var locale = props.controls.locale;
    var isChinaHost = countryCode === _AaConstants.COUTRY_CODE.CHINA || window.location.hostname.includes(_AaConstants.CHINA_HOST);
    return locale === _AaConstants.CHINA_LOCALE && isChinaHost;
  };

  var withChinaDisclaimer = function withChinaDisclaimer(redirectFunction) {
    return function (url) {
      if (_AaPlatform["default"].IS_WEB && canShowChinaDisclaimer()) {
        props.controls.chinaDisclaimerService('hotel_search', props.controls.locale, url);
        return;
      }

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      redirectFunction.apply(void 0, [url].concat(args));
    };
  };

  var redirectToAirasiaGo = withChinaDisclaimer(function (AAGoRedirectionUrl) {
    if (_AaPlatform["default"].IS_WEB) {
      window.open(AAGoRedirectionUrl, '_blank');
    } else {
      var payloadForMobile = (0, _AaSearchUrl.createMobilePayload)(_AaSearchUrl.MOBILE_PROVIDERS.AAGO, AAGoRedirectionUrl);
      performMobileRedirect(payloadForMobile);
    }
  });
  var openUrl = withChinaDisclaimer(_reactNativeWeb.Linking.openURL);

  var sendSearchHistory = function sendSearchHistory() {
    if (_AaPlatform["default"].IS_MOBILE) {
      _AaNativeModules["default"].ReactToNative.sendSearchHistory('hotel', _AaRecentSearchesRepository["default"].getRecentSearches());
    }
  };

  var searchHotel = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var AAGoRedirectionUrl, isValidLocale, isAllowedCountry, _props$controls2, locale, currency, environment, searchParams, urlBuilder, finalRedirectionUrl, listingProps, enableWebIos, enableWebAndroid, payloadForMobile;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              trackSearchHotel();

              if (!(selectedDestination && tripDates.checkinDate && tripDates.checkoutDate)) {
                _context.next = 40;
                break;
              }

              AAGoRedirectionUrl = createAAGoUrl();
              setFinalAAGoRedirection(AAGoRedirectionUrl);
              isValidLocale = featureFlags.ENABLE_HOTEL_LANGUAGE_SUPPORT.includes(props.controls.locale);
              isAllowedCountry = featureFlags.HOTEL_DISABLE_COUNTRY_FILTER || config.country.includes(selectedDestination.country_code);

              if (!(isAllowedCountry && isValidLocale)) {
                _context.next = 34;
                break;
              }

              _props$controls2 = props.controls, locale = _props$controls2.locale, currency = _props$controls2.currency, environment = _props$controls2.environment;
              searchParams = {
                currency: currency,
                locale: locale,
                destination: selectedDestination,
                rooms: roomOccupancy,
                tripDates: tripDates,
                countryCode: (0, _get2["default"])(props, 'async_nearest_airports.userData.data.country'),
                agentId: props.controls.agentId
              };
              urlBuilder = (0, _AaSearchUrl["default"])(environment);
              finalRedirectionUrl = urlBuilder.build(searchParams);
              listingProps = urlBuilder.buildMobileProps(searchParams);

              if (!_AaPlatform["default"].IS_WEB) {
                _context.next = 29;
                break;
              }

              if (!searchParams.agentId) {
                _context.next = 26;
                break;
              }

              setIsLoadingSearchButton(true);
              _context.prev = 15;
              _context.next = 18;
              return setHotelAgentToken();

            case 18:
              _context.next = 23;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](15);
              return _context.abrupt("return");

            case 23:
              _context.prev = 23;
              setIsLoadingSearchButton(false);
              return _context.finish(23);

            case 26:
              openUrl(finalRedirectionUrl);
              _context.next = 32;
              break;

            case 29:
              enableWebIos = _AaPlatform["default"].IS_IOS && featureFlags.ENABLE_HOTEL_WEB_IOS;
              enableWebAndroid = _AaPlatform["default"].IS_ANDROID && featureFlags.ENABLE_HOTEL_WEB_ANDROID;

              if (enableWebIos || enableWebAndroid) {
                payloadForMobile = (0, _AaSearchUrl.createMobilePayload)(_AaSearchUrl.MOBILE_PROVIDERS.WEB, finalRedirectionUrl);
                performMobileRedirect(payloadForMobile);
              } else {
                // Perform redirection without calling native module
                props.navigation.navigate('HotelListing', listingProps);
              }

            case 32:
              _context.next = 36;
              break;

            case 34:
              redirectToAirasiaGo(AAGoRedirectionUrl);
              trackRedirectedTarget('AAGo');

            case 36:
              _AaRecentSearchesRepository["default"].addRecentSearch(buildRecentSearch());

              sendSearchHistory();
              _context.next = 48;
              break;

            case 40:
              setDisableSearchButton(false);
              trackEmptySearchField(); //Error handling goes here

              console.log("Error in Fields");
              console.log("RD : ", tripDates.checkoutDate);
              console.log("DD : ", tripDates.checkinDate);
              console.log("Selected destination : ", selectedDestination);
              console.log("DEST_VALID : ", destinationValid);
              setShowFormErrors(true);

            case 48:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[15, 20, 23, 26]]);
    }));

    return function searchHotel() {
      return _ref.apply(this, arguments);
    };
  }();

  var setHotelAgentToken = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var _channels$find;

      var _props$controls3, environment, agentId, channelHash, response, _yield$response$json, token;

      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _props$controls3 = props.controls, environment = _props$controls3.environment, agentId = _props$controls3.agentId;
              channelHash = (_channels$find = channels.find(function (channel) {
                return channel.CHANNEL_ID === 'LEMWEBA';
              })) === null || _channels$find === void 0 ? void 0 : _channels$find.CHANNEL_HASH;
              _context2.next = 4;
              return fetch(_EnvironmentUrl["default"][environment].HOTEL_ACCESS_TOKEN, {
                method: 'POST',
                headers: {
                  Authorization: channelHash,
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  agent_id: agentId
                })
              });

            case 4:
              response = _context2.sent;

              if (!(response.status === 200)) {
                _context2.next = 13;
                break;
              }

              _context2.next = 8;
              return response.json();

            case 8:
              _yield$response$json = _context2.sent;
              token = _yield$response$json.token;
              (0, _AaCookie.createCookie)({
                name: 'lemonAgent',
                value: token,
                minutes: 60,
                domain: (0, _AaCookie.getCookieDomain)(environment)
              });
              _context2.next = 14;
              break;

            case 13:
              return _context2.abrupt("return", Promise.reject(new Error('Unable to get token')));

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function setHotelAgentToken() {
      return _ref2.apply(this, arguments);
    };
  }();

  var buildRecentSearch = function buildRecentSearch() {
    var checkinDate = tripDates.checkinDate,
        checkoutDate = tripDates.checkoutDate;
    var _selectedDestination$ = selectedDestination.typeWithoutTranslation,
        typeWithoutTranslation = _selectedDestination$ === void 0 ? selectedDestination.type : _selectedDestination$,
        id = selectedDestination.id,
        name = selectedDestination.name,
        full_name = selectedDestination.full_name,
        city_id = selectedDestination.city_id,
        country_code = selectedDestination.country_code;
    var recentSearch = {
      destination: {
        type: typeWithoutTranslation,
        id: id,
        name: name,
        full_name: full_name,
        isRecentSearches: true,
        city_id: city_id,
        country_code: country_code
      },
      date: {
        checkin: (0, _format["default"])(checkinDate, _AaSearchUrl.AA_DATE_FORMAT),
        checkout: (0, _format["default"])(checkoutDate, _AaSearchUrl.AA_DATE_FORMAT)
      },
      rooms: roomOccupancy,
      created_at: new Date().toISOString()
    };
    return recentSearch;
  };

  var createAAGoUrl = function createAAGoUrl() {
    var uhfCurrency = props.controls.currency.toUpperCase();
    var componentLabels = props.controls.componentLabels;
    var _componentLabels$hote = componentLabels.hotels,
        gutm = _componentLabels$hote.gutm,
        mobilegutm = _componentLabels$hote.mobilegutm,
        AAA = _componentLabels$hote.AAA;
    var defaultBaseUrl = AAA || _DefaultConfig["default"].hotels.AAA;
    var baseUrl = componentLabels.hotels[uhfCurrency] || defaultBaseUrl;
    return "".concat(baseUrl).concat(_AaPlatform["default"].IS_WEB ? gutm : mobilegutm);
  };

  var searchHandler = function searchHandler() {
    var isDestinationChina = false;
    var isRedirectFlagChina = featureFlags.ENABLE_HOTEL_REDIRECT_CTRIP;
    var airAsiaCN = _DefaultConfig["default"].ctrip_origin_domain;

    if (_AaPlatform["default"].IS_WEB && window.location.hostname.toLowerCase().indexOf(airAsiaCN) > -1 && selectedDestination) {
      isDestinationChina = true;
    }

    if (isDestinationChina && _AaPlatform["default"].IS_WEB && isRedirectFlagChina) {
      var checkinDate = tripDates.checkinDate,
          checkoutDate = tripDates.checkoutDate;
      var ctripCityId = 0;

      if (selectedDestination.city_id) {
        var ctripCity = _CtripMapCity["default"].find(function (e) {
          return e.aa_location_id === selectedDestination.city_id.toString();
        });

        ctripCityId = ctripCity && ctripCity.ctrip_id ? ctripCity.ctrip_id : ctripCityId;
      } // Just redirect when mapped with china location.


      if (ctripCityId) {
        var url = "".concat(_DefaultConfig["default"].ctrip_url, "?checkin=").concat((0, _format["default"])(checkinDate, _DefaultConfig["default"].CTRIP_FORMAT_DATE), "&checkout=").concat((0, _format["default"])(checkoutDate, _DefaultConfig["default"].CTRIP_FORMAT_DATE), "&allianceid=1261213&sid=3261365");
        url += "&city=".concat(ctripCityId);
        window.location.replace(url);
        return;
      }
    }

    if (props.controls.searchHandler) {
      var _props$controls4 = props.controls,
          locale = _props$controls4.locale,
          currency = _props$controls4.currency,
          environment = _props$controls4.environment;
      var searchParams = {
        currency: currency,
        locale: locale,
        destination: selectedDestination,
        rooms: roomOccupancy,
        tripDates: tripDates,
        countryCode: (0, _get2["default"])(props, 'async_nearest_airports.userData.data.country'),
        agentId: props.controls.agentId
      };
      var urlBuilder = (0, _AaSearchUrl["default"])(environment);
      var listingProps = urlBuilder.buildParams(searchParams);
      props.controls.searchHandler(listingProps);

      if (_AaPlatform["default"].IS_MOBILE) {
        props.navigation.goBack();
      }

      if (selectedDestination.id) {
        _AaRecentSearchesRepository["default"].addRecentSearch(buildRecentSearch());

        sendSearchHistory();
      }
    } else {
      searchHotel();
    }
  };

  var aaButton = {
    controls: {
      onButtonPress: searchHandler,
      id: 'aa-web-search-button',
      disabled: isLoadingSearchButton,
      buttonDisabledColor: {
        backgroundColor: "#DC3224"
      },
      customStyle: {
        text: {
          fontWeight: _AaPlatform["default"].IS_IOS ? '600' : 'bold'
        },
        buttonContainer: {
          backgroundColor: _AaPlatform["default"].IS_IOS ? '#e10000' : '#DC3224'
        }
      }
    },
    data: {
      text: !isLoadingSearchButton ? (0, _AaHelpers.getLabelBasedOnLocale)("main.search", props.controls.componentLabels) : /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.ActivityIndicator, {
        size: "large",
        color: "white",
        style: {
          height: 20,
          width: 20
        }
      })
    }
  };

  var openSearchWidgetModalMobileView = function openSearchWidgetModalMobileView(bool) {
    if (_AaPlatform["default"].IS_WEB) {
      setSearchWidgetModalStatus(bool);
      setSyncPlacePickerData(bool);
      document.getElementById("aa-modal-mobile-view").className = "open-modal";
    }
  };

  var onLoadSuggestions = function onLoadSuggestions(filterText, suggestions) {// const withDropdownLabel =
    //     suggestions.length > 0
    //         ? 'with drop down'
    //         : 'without drop down';
    // // trackEventNoEcommerce({
    // //     category: 'hpsearchwidget',
    // //     action: 'search',
    // //     label: `hotel sa | ${filterText} | ${withDropdownLabel}`
    // // });
  };

  var closeSearchWidgetModal = function closeSearchWidgetModal(event) {
    event.preventDefault();

    if (_AaPlatform["default"].IS_MOBILE) {
      if (props.controls.isSearchAgain) {
        props.navigation.goBack();
      } else {
        _AaNativeModules["default"].ReactToNative.closeRNScreen();
      }
    } else {
      setSearchWidgetModalStatus(false);
      setSelectedDestination(null);
      setTimeout(function () {
        var mobileElement = document.getElementById("aa-modal-mobile-view");

        if (Boolean(mobileElement)) {
          mobileElement.className = "";
        }
      }, 0);
      props.controls.closeSearchWidget();
    }
  };

  var calendarOutputHandler = function calendarOutputHandler(data) {
    isDestinationSelected(false);
    setTripDates({
      checkinDate: data.dates.checkinDate,
      checkoutDate: data.dates.checkoutDate
    });
  };

  var calendarConfig = {
    controls: {
      calendarOutput: calendarOutputHandler,
      maxDays: parseInt((0, _AaHelpers.getLabelBasedOnLocale)("hotels.maxDate", props.controls.componentLabels, '400'), 10),
      maxRangeDays: parseInt((0, _AaHelpers.getLabelBasedOnLocale)("hotels.dateRange", props.controls.componentLabels, '28'), 10),
      isDestinationStationSelected: destinationSelected,
      isLogin: props.controls.is_login
    }
  };

  var updateDestination = function updateDestination(destinationObject, selectedIndex) {
    setSelectedDestination(destinationObject);

    if (destinationObject) {
      trackSelectedDestination(destinationObject, selectedIndex);
    }
  };

  _react["default"].useEffect(function () {
    if (!props.baseCurrency) {
      return;
    }

    if (!props.baseCurrency.userData || !props.baseCurrency.userData.data) {
      return;
    }

    setBaseCurrency(props.baseCurrency.userData.data);
    props.make_async_get_call((0, _AaHelpers.format)(_EnvironmentUrl["default"][props.controls.environment].MULTI_CURRENCY, [props.baseCurrency.userData.data.toLowerCase()]), null, _stateVariables["default"].multi_currency);
  }, [props.baseCurrency]);

  var setExchangeRateAndCollectedCurrency = function setExchangeRateAndCollectedCurrency() {
    if (!props.multiCurrency || !props.baseCurrency) {
      setCollectedCurrency(null);
      return;
    } // if(!props.multiCurrency.userData || !props.multiCurrency.userData.data){
    //     // setCollectedCurrency(null);
    //     setExchangeRate(1);
    //     return;
    // }


    if (!props.baseCurrency.userData || !props.baseCurrency.userData.data) {
      setCollectedCurrency(null);
      return;
    }

    var multicurrencyList = props.multiCurrency.userData.data;

    if (!multicurrencyList || !multicurrencyList[props.controls.currency.toUpperCase()]) {
      setCollectedCurrency(props.baseCurrency.userData.data);
    } else {
      setCollectedCurrency(props.controls.currency.toUpperCase());
    }

    var exchangeRate = multicurrencyList && multicurrencyList[props.controls.currency.toUpperCase()] ? multicurrencyList[props.controls.currency.toUpperCase()] : 1;
    setExchangeRate(Number(exchangeRate));
  };

  _react["default"].useEffect(function () {
    setExchangeRateAndCollectedCurrency();
  }, [props.controls.currency, props.multiCurrency]);

  var destinationStationSelected = function destinationStationSelected(bool) {
    isDestinationSelected(bool);
  };

  var updateSearchTerm = function updateSearchTerm(searchTerm) {
    setDestinationSearchTerm(searchTerm);
  };

  var isOriginValid = function isOriginValid(bool) {
    if (!bool) {
      setSelectedDestination(null);
    }
  };

  var isDestinationValid = function isDestinationValid(bool) {
    setDestinationValidState(bool);
  };

  var calendarLayout = {
    isMobile: mobileScreen || showMobileWeb,
    isTablet: tabletScreen && !showMobileWeb,
    isDesktop: desktopScreen && !showMobileWeb
  };

  var _useState37 = (0, _react.useState)(false),
      _useState38 = (0, _slicedToArray2["default"])(_useState37, 2),
      isBannerFocused = _useState38[0],
      setBannerFocused = _useState38[1];

  _react["default"].useEffect(function () {
    var environment = props.controls.environment;
    var image = {
      uri: _EnvironmentUrl["default"][environment].HOTEL_MOBILE_BANNER
    };

    if (!isBannerFocused) {
      var urlArray = image && image.uri.split('/');
      var bannerWithEnv = urlArray && decodeURIComponent(urlArray[urlArray.length - 1].split('.')[0]);
      var bannerName = bannerWithEnv && bannerWithEnv.split('-').slice(1).join(" ");
      setBannerFocused(true);
      var ecommerceInfo = {
        category: 'Hotels SA |herobanner',
        action: actions.view,
        label: "".concat(bannerName, "| 1"),
        screenName: 'Search widget',
        lineofbusiness: 'HOTELS SA'
      };
      (0, _GTMTracking.trackEventEcommerce)(actions.view, ecommerceInfo);
    }
  }, [isBannerFocused]);
  /*
  * Common code base for mobile view of search widget for mobile web and mobile platforms
  * */


  var mobileViewSearchWidget = function mobileViewSearchWidget() {
    var HOTEL_TILE_INDEX = 1;
    var titleLabel = (0, _get2["default"])(props, "async_product_tiles.userData.data.web[".concat(HOTEL_TILE_INDEX, "].label"), '');
    var _props$controls5 = props.controls,
        environment = _props$controls5.environment,
        forceMobileView = _props$controls5.forceMobileView;
    var image = {
      uri: _EnvironmentUrl["default"][environment].HOTEL_MOBILE_BANNER
    };
    var showBanner = !forceMobileView && featureFlags.HOTEL_ENABLE_MOBILE_BANNER;
    var headerProps = {
      onClose: closeSearchWidgetModal,
      titleLabel: titleLabel
    };
    return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: _SearchFormStyles["default"].widgetModalContainer
    }, !showBanner && /*#__PURE__*/_react["default"].createElement(_airasiaMobileHeaderContainer.MobileHeader, headerProps), showBanner && /*#__PURE__*/_react["default"].createElement(_airasiaMobileHeaderContainer.BannerMobileHeader, (0, _extends2["default"])({
      image: image
    }, headerProps)), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: _SearchFormStyles["default"].mobileViewForm
    }, /*#__PURE__*/_react["default"].createElement(_AaLocationPicker["default"], {
      isNewDesign: featureFlags.HOTEL_ENABLE_SUGGESTIONS_NEW_DESIGN,
      controls: {
        updateSearchTerm: updateSearchTerm,
        environment: props.controls.environment,
        locale: props.controls.locale,
        componentLabels: props.controls.componentLabels,
        openSearchWidgetModalMobileView: openSearchWidgetModalMobileView,
        updateOrigin: updateDestination,
        syncPlacePickerData: syncPlacePickerData,
        syncOrigin: selectedDestination,
        isDestinationSelected: destinationStationSelected,
        isOriginValid: isOriginValid,
        isDestinationValid: isDestinationValid,
        showFormErrors: showFormErrors,
        forceMobileView: showMobileWeb,
        onLoadSuggestions: onLoadSuggestions
      }
    }), /*#__PURE__*/_react["default"].createElement(_AaCalendar["default"], {
      controls: _objectSpread(_objectSpread({}, calendarConfig.controls), {}, {
        viewType: _AaCalendar2.CALENDAR_VIEW_TYPE.MOBILE,
        layout: calendarLayout,
        locale: props.controls.locale,
        currencyDetails: {
          currencyCode: baseCurrency,
          collectedCurrency: collectedCurrency,
          exchangeRate: exchangeRate
        },
        environment: props.controls.environment
      }),
      data: tripDates,
      widgetData: {
        roomOccupancy: roomOccupancy,
        currency: props.controls.currency,
        token: props.controls.token,
        checkinDate: tripDates.checkinDate,
        checkoutDate: tripDates.checkoutDate
      },
      translation: {
        departLabel: (0, _AaHelpers.getLabelBasedOnLocale)("hotels.checkinDate_label", props.controls.componentLabels),
        returnLabel: (0, _AaHelpers.getLabelBasedOnLocale)("hotels.checkoutDate_label", props.controls.componentLabels),
        confirmLabel: (0, _AaHelpers.getLabelBasedOnLocale)("calendar.ctaConfirm", props.controls.componentLabels),
        resetLabel: (0, _AaHelpers.getLabelBasedOnLocale)("calendar.reset", props.controls.componentLabels)
      }
    }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: _SearchFormStyles["default"].passengerRowMobileView
    }, /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelection["default"], {
      controls: passengerSelectionConfig.controls,
      data: roomOccupancy,
      ageList: AGE_DATA,
      translation: (0, _AaPassengerRoomSelection3["default"])(props.controls.componentLabels)
    })), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: _SearchFormStyles["default"].show
    }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaButton, {
      controls: aaButton.controls,
      data: aaButton.data
    }))));
  };

  var _useState39 = (0, _react.useState)(false),
      _useState40 = (0, _slicedToArray2["default"])(_useState39, 2),
      isDestinationFocused = _useState40[0],
      setDestinationFocused = _useState40[1];

  var _useState41 = (0, _react.useState)(false),
      _useState42 = (0, _slicedToArray2["default"])(_useState41, 2),
      isCalendarFocused = _useState42[0],
      setCalendarFocused = _useState42[1];

  var _useState43 = (0, _react.useState)(false),
      _useState44 = (0, _slicedToArray2["default"])(_useState43, 2),
      isRoomSelectFocused = _useState44[0],
      setRoomSelectFocused = _useState44[1];

  _react["default"].useEffect(function () {
    var showInputOverlay = isDestinationFocused || isCalendarFocused || isRoomSelectFocused;
    props.onFormFocused(showInputOverlay);
  }, [isDestinationFocused, isCalendarFocused, isRoomSelectFocused]);
  /*
  * Block for desktop and tablet screens
  * */


  if (!showMobileWeb && _AaPlatform["default"].IS_WEB) {
    var isSearchAgain = props.controls.isSearchAgain;
    var roomSelectionProps = {
      controls: _objectSpread(_objectSpread({}, passengerSelectionConfig.controls), {}, {
        showResultAsInput: isSearchAgain,
        isLeftAligned: isSearchAgain && !tabletScreen,
        onFocus: setRoomSelectFocused
      }),
      data: roomOccupancy,
      translation: (0, _AaPassengerRoomSelection3["default"])(props.controls.componentLabels),
      ageList: {
        AGE_DATA: AGE_DATA
      }
    };

    if (isSearchAgain) {
      aaButton.controls.customStyle.buttonContainer.paddingVertical = 15;
    }

    var showInputOverlay = isDestinationFocused || isCalendarFocused || isRoomSelectFocused;
    var isInputFocus = isSearchAgain && showInputOverlay;
    return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [_SearchFormStyles["default"].searchView, isSearchAgain && _SearchAgain["default"].searchView]
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [_SearchFormStyles["default"].upperContainer, tabletScreen && _SearchFormStyles["default"].TabletView]
    }, isInputFocus && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: _SearchAgain["default"].overlay
    }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [desktopScreen && _SearchFormStyles["default"].desktopWidth, inputStylingChange && _SearchFormStyles["default"].elementContainer, isSearchAgain && _SearchAgain["default"].input]
    }, /*#__PURE__*/_react["default"].createElement(_AaLocationPicker["default"], {
      isNewDesign: featureFlags.HOTEL_ENABLE_SUGGESTIONS_NEW_DESIGN,
      controls: {
        updateSearchTerm: updateSearchTerm,
        environment: props.controls.environment,
        isDesktop: desktopScreen,
        locale: props.controls.locale,
        componentLabels: props.controls.componentLabels,
        updateOrigin: updateDestination,
        syncPlacePickerData: syncPlacePickerData,
        syncOrigin: selectedDestination,
        onInputMakeStyleChange: onInputMakeStyleChange,
        onInputFocus: setDestinationFocused,
        isDestinationSelected: destinationStationSelected,
        isOriginValid: isOriginValid,
        isDestinationValid: isDestinationValid,
        showFormErrors: showFormErrors,
        onLoadSuggestions: onLoadSuggestions
      }
    })), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [_SearchFormStyles["default"].calendarContainer, isSearchAgain && _SearchAgain["default"].input, isSearchAgain && _SearchAgain["default"].calendar, isCalendarFocused && isSearchAgain && _SearchAgain["default"].focusedInput]
    }, /*#__PURE__*/_react["default"].createElement(_AaCalendar["default"], {
      controls: _objectSpread(_objectSpread({}, calendarConfig.controls), {}, {
        hideCalendarIcon: isSearchAgain,
        isRightAligned: isSearchAgain,
        onFocus: setCalendarFocused,
        layout: calendarLayout,
        locale: props.controls.locale,
        currencyDetails: {
          currencyCode: baseCurrency,
          collectedCurrency: collectedCurrency,
          exchangeRate: exchangeRate
        },
        environment: props.controls.environment,
        isCalendarOpenedByDeepLink: props.controls.isCalendarOpenedByDeepLink
      }),
      data: tripDates,
      widgetData: {
        roomOccupancy: roomOccupancy,
        currency: props.controls.currency,
        token: props.controls.token,
        checkinDate: tripDates.checkinDate,
        checkoutDate: tripDates.checkoutDate
      },
      translation: {
        departLabel: (0, _AaHelpers.getLabelBasedOnLocale)("hotels.checkinDate_label", props.controls.componentLabels),
        returnLabel: (0, _AaHelpers.getLabelBasedOnLocale)("hotels.checkoutDate_label", props.controls.componentLabels),
        confirmLabel: (0, _AaHelpers.getLabelBasedOnLocale)("calendar.ctaConfirm", props.controls.componentLabels),
        resetLabel: (0, _AaHelpers.getLabelBasedOnLocale)("calendar.reset", props.controls.componentLabels)
      }
    })), isSearchAgain && desktopScreen && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [_SearchAgain["default"].occupancy, isRoomSelectFocused && _SearchAgain["default"].focusedInput]
    }, /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelection["default"], roomSelectionProps)), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [_SearchFormStyles["default"].show, _SearchFormStyles["default"].buttonContainer, desktopScreen ? _SearchFormStyles["default"].onDesktopButton : _SearchFormStyles["default"].hide, isSearchAgain && _SearchAgain["default"].button]
    }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaButton, {
      controls: aaButton.controls,
      data: aaButton.data
    }))), (!isSearchAgain || tabletScreen) && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [_SearchFormStyles["default"].lowerContainer, desktopScreen && _AaPlatform["default"].IS_WEB && _SearchFormStyles["default"].spaceBetween, isRoomSelectFocused && isSearchAgain && _SearchAgain["default"].focusedInput]
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: tabletScreen && _AaPlatform["default"].IS_WEB && _SearchFormStyles["default"].setFlex
    }, /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelection["default"], roomSelectionProps))), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [tabletScreen && _AaPlatform["default"].IS_WEB ? _SearchFormStyles["default"].show : _SearchFormStyles["default"].hide, {
        maxWidth: 596,
        margin: 'auto'
      }]
    }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaButton, {
      controls: aaButton.controls,
      data: aaButton.data
    })));
  }
  /*
  * Block for mobile web
  * */


  if (showMobileWeb) {
    //View for SearchWidget Homepage
    return /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaModal, {
      isVisible: searchWidgetModalStatus,
      wrapperStyle: _SearchFormStyles["default"].modal,
      onClose: closeSearchWidgetModal
    }, mobileViewSearchWidget());
  }
  /*
  * Block for android
  * */


  if (_AaPlatform["default"].IS_ANDROID) {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: _SearchFormStyles["default"].safeAreaView
    }, mobileViewSearchWidget());
  }
  /*
  * Block for iOS
  * */


  if (_AaPlatform["default"].IS_IOS) {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.SafeAreaView, {
      style: _SearchFormStyles["default"].safeAreaView
    }, mobileViewSearchWidget());
  }
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    async_all_station_data: state.asyncAction[_stateVariables["default"].all_stations],
    async_all_station_data_Loading: state.asyncAction[_stateVariables["default"].all_stations] && state.asyncAction[_stateVariables["default"].all_stations].isFetching,
    async_all_station_data_Error: state.asyncAction[_stateVariables["default"].all_stations] && state.asyncAction[_stateVariables["default"].all_stations].isError,
    async_nearest_airports: state.asyncAction[_stateVariables["default"].nearest_airports],
    async_nearest_airports_Error: state.asyncAction[_stateVariables["default"].nearest_airports] && state.asyncAction[_stateVariables["default"].nearest_airports].isError,
    dataFormatDate: state.asyncAction[_stateVariables["default"].data_format_date],
    baseCurrency: state.asyncAction[_stateVariables["default"].base_currency],
    multiCurrency: state.asyncAction[_stateVariables["default"].multi_currency],
    async_searchDeepLinkData: state.asyncAction[_stateVariables["default"].search_deep_link_data],
    async_searchDeepLinkData_Loading: state.asyncAction[_stateVariables["default"].search_deep_link_data] && state.asyncAction[_stateVariables["default"].search_deep_link_data].isFetching,
    async_searchDeepLinkData_Error: state.asyncAction[_stateVariables["default"].search_deep_link_data] && state.asyncAction[_stateVariables["default"].search_deep_link_data].isError,
    async_channel: state.asyncAction[_stateVariables["default"].channel],
    async_aoc: state.asyncAction[_stateVariables["default"].aoc],
    async_aoc_Error: state.asyncAction[_stateVariables["default"].aoc] && state.asyncAction[_stateVariables["default"].aoc].isError,
    async_feature_flag: state.asyncAction[_stateVariables["default"].feature_flag],
    async_config: state.asyncAction[_stateVariables["default"].config],
    async_product_tiles: state.asyncAction[_stateVariables["default"].product_tiles]
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  make_async_get_call: _uiUtils.make_async_get_call,
  make_async_call: _uiUtils.make_async_call
})((0, _crossPlatformComponents.withLayoutContext)(SearchForm));

exports["default"] = _default;